import type { OtherCostKeys } from "../shapes/ShapeOtherCostsGroup.js";
import type { AppraisalDocumentFacade } from "./AppraisalDocumentFacade.js";
import type { WithRelativesSetDelegate } from "./delegates/WithRelativesSetDelegate.js";
import {
  readOnlyRelativesSetFacadeWithAbsolute,
  type RelativesSetFacade,
} from "./RelativesSetFacade.js";

export type OtherCostsRelativesStore = RelativesSetFacade<
  OtherCostKeys,
  WithRelativesSetDelegate<OtherCostKeys>
>;

export const createOtherCostsRelatives = (
  appraisal: AppraisalDocumentFacade,
): OtherCostsRelativesStore =>
  readOnlyRelativesSetFacadeWithAbsolute(
    {
      relatives: {
        absolute: appraisal.otherCostsTotal?.toFraction() ?? null,
        ratioBuildCostGlobalTotal: null,
        ratioGdv: null,
      },
    },
    {
      ratioBuildCostGlobalTotal: () =>
        appraisal.stages.build.buildCostGlobalTotal,
      ratioGdv: () => appraisal.stages.revenue.getGrossDevelopmentValue("any"),
    },
  );
